import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 10,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    transportCompanyID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'transport.transportCompany',
        required: true,
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['transportCompany/isLoading'],
        options: vue.$store.getters['transportCompany/loadedItems']
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    parcelTypes: {
      type: Select,
      defaultValue: [],
      props: {
        caption: 'transport.parcelTypes',
        valueField: 'id',
        labelField: 'description',
        multiple: true,
        options: vue.$store.getters['parcelType/loadedItems'],
        loading: vue.$store.getters['parcelType/isLoading']
      }
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
